import { Flex } from '@billy/design-system'
import { css } from '@emotion/core'
import React from 'react'

import { reactClass } from '../../../utils'

type DroppableContainerProps = {
  children: React.ReactNode
  className?: string
  highlightOnDraggingOver?: boolean
  isDraggingOver?: boolean
  draggingOverWith?: string | null
  draggingFromThisWith?: string | null
  css?: any
}

export const DroppableContainer = React.forwardRef(
  (
    {
      children,
      className,
      draggingFromThisWith,
      draggingOverWith,
      highlightOnDraggingOver,
      isDraggingOver,
      css: outsideCss,
      ...rest
    }: DroppableContainerProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={ref}
        css={[
          css`
            margin: 0;
            box-sizing: border-box;
            min-width: 0;
          `,
        ]}
      >
        <Flex
          className={reactClass('droppable-container') + className}
          css={[
            css`
              position: relative;
              flex-direction: column;
              min-height: 30px;
            `,
            outsideCss,
          ]}
          {...rest}
        >
          {children}
        </Flex>
      </div>
    )
  },
)
